var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.post.operation === 'create')?_c('Artifact',{attrs:{"post":_vm.post}}):_vm._e(),(_vm.post.operation === 'create_kr_checkin')?_c('LogDetails',{attrs:{"details":_vm.post.details}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }